import script from "./BannerWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./BannerWidget.vue?vue&type=script&setup=true&lang=ts"

import "./BannerWidget.vue?vue&type=style&index=0&id=1cc28470&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cc28470"]])

export default __exports__